import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6891987b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-2 text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "question-title my-1" }, "📖", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "question-title my-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "my-2" }
const _hoisted_8 = { class: "my-3" }
const _hoisted_9 = { class: "my-3" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "my-3" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelBadge = _resolveComponent("LevelBadge")!
  const _component_Example = _resolveComponent("Example")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.question.word.word), 1),
      _hoisted_6,
      _createVNode(_component_LevelBadge, {
        class: "my-1",
        icon: "📖",
        score: _ctx.question.word.readingScore,
        level: _ctx.question.word.readingLevel,
        progress: _ctx.question.word.readingProgress
      }, null, 8, ["score", "level", "progress"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Example, {
        example: _ctx.question.example
      }, null, 8, ["example"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", null, "Q: " + _toDisplayString(_ctx.question.question), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('answer', _ctx.answer)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t('practice.answer')) + ": ", 1),
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "data-bs-theme": "dark",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.answer.choice) = $event)),
            required: ""
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.choices, (choice, idx) => {
              return (_openBlock(), _createElementBlock("option", { value: choice }, _toDisplayString(choice), 9, _hoisted_10))
            }), 256))
          ], 512), [
            [_vModelSelect, _ctx.answer.choice]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-secondary",
            disabled: _ctx.answerLoading || _ctx.answered
          }, _toDisplayString(_ctx.$t('practice.answerButton')), 9, _hoisted_12)
        ])
      ], 32)
    ])
  ]))
}